module.exports = __webpack_public_path__ + "static/logo2.a610ec5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo2.png
// module id = 676
// module chunks = 114276838955818